exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Variables\n */\n\n/**\n * Functions\n */\n\n/**\n * Mixins\n */\n.type-select-screen[data-v-1cb66c32] {\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-ms-flex-align: center;\n\talign-items: center;\n\ttext-align: center;\n\tgap: 36px;\n\tgap: 2.25rem;\n}\n.title[data-v-1cb66c32] {\n\tmargin: 0;\n}\n.description[data-v-1cb66c32] {\n\tmargin: 0;\n}\n.type-select[data-v-1cb66c32] {\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tgap: 36px;\n\tgap: 2.25rem;\n\twidth: 100%;\n}\n", ""]);

// exports
